import axios from "@/libs/api.request";
import { common } from "./api_url";
/**
 * 获取通讯组列表
 * @param data
 * @returns {*|{responseURL}}
 */
export const GetCustomerSourceList = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.GetCustomerSourceList,
    params: {
      ...data,
      country_code
    },
    method: "get"
  });
};
/**
 * 获取所有枚举
 * @param data
 * @returns {*|{responseURL}}
 */
export const getAllEnumType = data => {
   let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.getAllEnumType,
    params: {
      ...data,
      country_code
    },
    method: "get"
  });
};

export const GetImportDepartment = data => {
   let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.GetImportDepartment,
    params: {
      ...data,
      country_code
    },
    method: "get"
  });
};
export const QueryCustomerAptitudeLevel = data => {
   let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.QueryCustomerAptitudeLevel,
    params: {
      ...data,
      country_code
    },
    method: "get"
  });
};
/**
 * 上传文件
 * @param data
 * @param contentType
 * @returns {*|{responseURL}}
 */
export const UploadFile = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request(
    {
      url: common.UploadFile,
      data: {
        ...data,
        country_code
      },
      method: "post"
    },
    "FormData"
  );
};
/**
 * 获取文件
 * @param data
 * @returns {*|{responseURL}}
 * @constructor
 */
export const GetFile = data => {
   let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.GetFile,
    params: {
      ...data,
      country_code
    },
    method: "get"
  });
};

/**
 * 回复反馈
 */
export const ReplyFeedback = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.ReplyFeedback,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
/**
 * 查询反馈列表
 */
export const QueryFeedback = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.QueryFeedback,
    params: {
      ...data,
      country_code
    },
    method: "get"
  });
};
/**
 * 根据部门Id 获取部门的下一级部门列表和部门及下属所有部门的人员信息
 */
export const GetChildDeptAndAllPerson = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.GetChildDeptAndAllPerson,
    params: {
      ...data,
      country_code
    },
    method: "get"
  });
};
/**
 * 获得组织树
 * @param data
 * @returns {*|{responseURL}}
 * @constructor
 */
export const GetDeptTree = data => {
  let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: common.GetDeptTree,
    params: {
      ...data,
      country_code
    },
    method: "get"
  });
};
/**
 * 请求接口公用
 * @param {*} url
 * @param {*} data
 * @returns
 */
export const commonReq = (url, data) => {
 let country_code = localStorage.getItem("country_code");
  return axios.request({
    url: url,
    data: {
      ...data,
      country_code
    },
    method: "post"
  });
};
